@if (dashboard) {
  @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
    @if (last && breadcrumb.breadcrumbs !== false) {
      <div class="page-header" style="margin-top: -70px">
        <div class="page-block">
          <div class="row align-item-center">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <ul class="breadcrumb mb-0">
                  <app-nav-left></app-nav-left>

                  <li class="breadcrumb-item">
                    @if (type === 'theme2') {
                      <a (click)="router.navigate(['/dashboardTrueque'])" title="Home">
                        <i class="ti ti-home-2"></i>
                      </a>
                    }
                    @if (type === 'theme1') {
                      <a (click)="router.navigate(['/dashboardTrueque'])" title="Home">Home</a>
                    }
                  </li>
                  @for (breadcrumb of navigationList; track breadcrumb) {
                    @if (breadcrumb.url !== false) {
                      <li class="breadcrumb-item">
                        <a [routerLink]="breadcrumb.url">{{ breadcrumb.title | translate }}</a>
                      </li>
                    }
                    @if (breadcrumb.url === false && breadcrumb.type !== 'group') {
                      <li class="breadcrumb-item">
                        <a href="javascript:">{{ breadcrumb.title | translate }}</a>
                      </li>
                    }
                  }
                </ul>

                <div class="nombre-empresa" style="font-weight: bold">{{ nombreEmpresa }}</div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="page-header-title">
                @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
                  @if (last) {
                    <h2 class="f-w-700">
                      {{ breadcrumb.title | translate }}
                    </h2>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}

<!-- @if (Component) {
  @for (breadcrumb of componentList; track breadcrumb; let last = $last) {
    @if (last && breadcrumb.breadcrumbs !== false) {
      <div class="page-block">
        <div class="felx align-item-center">
          <div class="page-header-title">
            @for (breadcrumb of componentList; track breadcrumb; let last = $last) {
              @if (last) {
                <h2 class="m-b-5">
                  {{ breadcrumb.title }}
                </h2>
                <button mat-stroked-button class="bg-accent-300 b-rad-20 m-b-15 p-x-10">
                  <a href="{{ breadcrumb.url }}" target="_blank" class="text-accent-900">
                    <i class="ti ti-external-link"></i>
                    Reference
                  </a>
                </button>
              }
            }
          </div>
        </div>
      </div>
    }
  }
} -->
@if (Component) {
  @for (breadcrumb of componentList; track breadcrumb; let last = $last) {
    @if (last && breadcrumb.breadcrumbs !== false) {
      <div class="page-header" style="margin-top: -70px">
        <div class="page-block">
          <div class="row align-item-center">
            <div class="col-md-12">
              <div class="flex align-item-center">
                <ul class="breadcrumb align-item-center">
                  <li class="breadcrumb-item">
                    @if (type === 'theme2') {
                      <a (click)="router.navigate(['/dashboardTrueque'])" title="Home">
                        <i class="ti ti-home-2"></i>
                      </a>
                    }
                    @if (type === 'theme1') {
                      <a (click)="router.navigate(['/dashboardTrueque'])" title="Home">
                        <!-- <i class="ti ti-home-2"></i> -->
                        Home
                      </a>
                    }
                  </li>
                  @for (breadcrumb of componentList; track breadcrumb) {
                    @if (breadcrumb.url !== false) {
                      <li class="breadcrumb-item">
                        <a [routerLink]="breadcrumb.url">{{ breadcrumb.title | translate }}</a>
                      </li>
                    }
                    @if (breadcrumb.url === false && breadcrumb.type !== 'group') {
                      <li class="breadcrumb-item">
                        <a href="javascript:">{{ breadcrumb.title | translate }}</a>
                      </li>
                    }
                  }
                </ul>
              </div>
            </div>
            <div class="col-md-12">
              <div class="page-header-title">
                @for (breadcrumb of componentList; track breadcrumb; let last = $last) {
                  @if (last) {
                    <div class="header-line">
                      <button class="back-button" (click)="goBack('/dashboardTrueque')" aria-label="Volver">
                        <i class="fas fa-arrow-left"></i>
                      </button>
                      <h2 class="f-w-700">
                        {{ breadcrumb.title | translate }}
                      </h2>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}
